const Chip = ({ status, label, addStyle }: { status: string; label: string; addStyle?: object }) => {
  return (
    <div
      className="chip-container"
      style={{
        background:
          status === 'analysis-completed' || status === 'success' || status === 'paid' || status === 'completed' || status === 'approved' || status === 'accepted'
            ? '#F0FDF4'
            : status === 'analyzing' || status === 'warning' || status === 'processing' || status === 'validated' || status === 'pending-credit'
            ? '#FFFBEB'
            : status === 'dispersing' || status === 'main' || status === 'register-disperse-completed' || status === 'ready-for-disperse' || status === 'reviewed'
            ? '#F6FEFC'
            : status.indexOf('error') !== -1 ||
              status.indexOf('for-review-duplicate') !== -1 ||
              status === 'rejected' ||
              status === 'deleted' ||
              status === 'reverted' ||
              status === 'returned' ||
              status === 'without-starting' ||
              status === 'with-response'
            ? '#FEF2F2'
            : status === 'disabled' || status === 'for-review' || status === 'waiting-for-resolution' || status === 'pending'
            ? '#E5E5E5'
            : '#FFF',
        ...addStyle
      }}
    >
      <div
        className="chip-dot"
        style={{
          background:
            status === 'analysis-completed' || status === 'success' || status === 'paid' || status === 'completed' || status === 'approved' || status === 'accepted'
              ? '#22C55E'
              : status === 'analyzing' || status === 'warning' || status === 'processing' || status === 'validated' || status === 'pending-credit'
              ? '#F59E0B'
              : status === 'dispersing' || status === 'main' || status === 'register-disperse-completed' || status === 'ready-for-disperse' || status === 'reviewed'
              ? '#0cb7f2'
              : status.indexOf('error') !== -1 ||
                status.indexOf('for-review-duplicate') !== -1 ||
                status === 'rejected' ||
                status === 'deleted' ||
                status === 'reverted' ||
                status === 'returned' ||
                status === 'without-starting' ||
                status === 'with-response'
              ? '#EF4444'
              : status === 'disabled' || status === 'for-review' || status === 'waiting-for-resolution' || status === 'pending'
              ? '#A3A3A3'
              : '#FFF'
        }}
      ></div>
      <div
        className="chip-text"
        style={{
          color:
            status === 'analysis-completed' || status === 'success' || status === 'paid' || status === 'completed' || status === 'approved' || status === 'accepted'
              ? '#22C55E'
              : status === 'analyzing' || status === 'warning' || status === 'processing' || status === 'validated' || status === 'pending-credit'
              ? '#F59E0B'
              : status === 'dispersing' || status === 'main' || status === 'register-disperse-completed' || status === 'ready-for-disperse' || status === 'reviewed'
              ? '#0cb7f2'
              : status.indexOf('error') !== -1 ||
                status.indexOf('for-review-duplicate') !== -1 ||
                status === 'rejected' ||
                status === 'deleted' ||
                status === 'reverted' ||
                status === 'returned' ||
                status === 'without-starting' ||
                status === 'with-response'
              ? '#EF4444'
              : status === 'disabled' || status === 'for-review' || status === 'waiting-for-resolution' || status === 'pending'
              ? '#A3A3A3'
              : '#FFF'
        }}
      >
        {label}
      </div>
    </div>
  )
}

export default Chip
